export default "__VITE_ASSET__ZMJuJJi___"